import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SLICE_STATUS } from 'utils/constants';
import { getNavItems } from 'api/navItems';
import { NavItem } from 'types/store/nav';
import { RootState } from 'state/store';

interface NavigationState {
  navItems: NavItem[];
  status: typeof SLICE_STATUS[keyof typeof SLICE_STATUS];
}

const initialState: NavigationState = {
  navItems: [],
  status: SLICE_STATUS.IDLE,
};

export const fetchNavItems = createAsyncThunk(
  'navigation/FETCH_NAV_ITEMS',
  async () => {
    const response = await getNavItems();
    return response.data;
  }
);

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    resetNavItems: (state) => {
      state.navItems = initialState.navItems;
      state.status = initialState.status;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNavItems.pending, (state) => {
        state.status = SLICE_STATUS.LOADING;
      })
      .addCase(fetchNavItems.rejected, (state) => {
        state.status = SLICE_STATUS.FAILED;
      })
      .addCase(fetchNavItems.fulfilled, (state, action) => {
        state.navItems = action.payload;
        state.status = SLICE_STATUS.SUCCESS;
      });
  },
});

export const { resetNavItems } = navigationSlice.actions;

export const selectNavItems = (state: RootState) => state.navigation.navItems;
export const selectNavItemsStatus = (state: RootState) =>
  state.navigation.status;

export default navigationSlice.reducer;
